<div class="btn-group">
  <button
    type="button"
    class="btn btn-actions btn-actions--position btn-just-icon p-0 btn-sm mx-1 hvr-shrink descripcion-emergente-govco bottom"
    data-bs-toggle="dropdown"
    data-bs-auto-close="outside"
    aria-expanded="false"
    id="dropdownAlertasButton"
    (click)="marcarLeido()"
    aria-label="Ver alertas">
    <span class="tiptext">{{"visualizar_alertas.alertas" | translate}}</span>
    <div class="notification-icon d-flex flex-row align-items-center">
      <span class="govco-svg govco-bell icos__nav__user"></span>
      <span
        class="position-absolute top-0 start-100 translate-middle badge badge__Notifications rounded-pill bg-danger">
        {{ cambios }}
        <span class="visually-hidden">{{"visualizar_alertas.alertas_sin_leer" | translate}}</span>
      </span>
    </div>
  </button>

  <div
    id="dropdownAlertas"
    class="dropdown-menu dropdown-menu-end"
    data-bs-auto-close="outside"
    aria-labelledby="dropdownAlertasButton">
    <div class="col col-12 p-3">
      <div class="w-100 mt-4">
        <div class="row text-center border border-1 my-2 align-items-center">
          {{"visualizar_alertas.generado" | translate}} {{ actualizaciones }} {{"visualizar_alertas.cambios" | translate}}
        </div>
      </div>
    </div>
  </div>
</div>
